import { render } from "./ArtiCle.vue?vue&type=template&id=bce4e2d4&scoped=true&ts=true"
import script from "./ArtiCle.vue?vue&type=script&lang=ts"
export * from "./ArtiCle.vue?vue&type=script&lang=ts"

import "./ArtiCle.vue?vue&type=style&index=0&id=bce4e2d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce4e2d4"]])

export default __exports__